/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getEventTypes as getEventTypesRetrieve,
  postEventTypes,
  postEventTypesDelete,
} from 'api/pgads.js'
import { getEventTypes } from 'core/selectors'

import CommonScreen from './CommonScreen'
import { Button, Input } from 'antd'
import styled from 'styled-components'
import { EVENT_TYPES } from 'core/action-names'

const TableTD = styled.td`
  text-align: end;
  max-width: 100px;
  width: 100px;
`

const retrieveTask = apiTargetInfo => getEventTypesRetrieve(apiTargetInfo)

const modifyTask = apiTargetInfo => data => postEventTypes(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  postEventTypesDelete(apiTargetInfo)(data)

/* const monthOption = R.range(1, 13).map(i => ({
  key: i + '',
  value: i + '',
  text: i + '',
})) */

const headers = [
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    isRequired: true,
    width: 600,
  }),
]

const title = 'Event Types'

const EventTypesComp = props => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Event Type Id :</TableTD>
            <td colSpan={1} style={{ maxWidth: '100px' }}>
              <Input
                name="eventTypeId"
                style={{ maxWidth: '200px' }}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    eventType: e.target.value,
                  })
                }}
                maxLength={2}
              />
            </td>
            <TableTD>Description :</TableTD>
            <td colSpan={3}>
              <Input
                name="description"
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    description: e.target.value,
                  })
                }}
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
              <Button
                type="primary"
                onClick={() => onAdd(false)}
                style={{ marginLeft: '20px' }}
              >
                Add & Hide
              </Button>
              <Button
                type="danger"
                onClick={onCancel}
                style={{ marginLeft: '20px' }}
              >
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const onRetrieveData = data => {
    props.saveEventTypeMap(data)
  }

  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.unit}
      autoRetrieve
      // sortOptions={[
      //   { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
      //   { ident: 'unit', display: 'Unit', sortOrder: 'asc' },
      // ]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      widthOffset={550}
      // heightOffset={100}
      // withDelete={false}
      onRetrieveData={onRetrieveData}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  eventTypes: getEventTypes(state),
})

const mapDispatchToMap = dispatch => ({
  saveEventTypeMap: data => dispatch({ type: EVENT_TYPES, payload: data }),
  // saveStation
})

export default connect(mapStateToProps, mapDispatchToMap)(EventTypesComp)
